import { gql } from "@apollo/client";

export const GET_RECEIVER_DATA = gql`
query GetReceiversOfCustomer($page: Int, $limit: Int, $filter: String, $sort: orderSort, $customerId: ID) {
  getReceiversOfCustomer(page: $page, limit: $limit, filter: $filter, sort: $sort, customerId: $customerId) {
    count
    data {
      id
      name
      phone
      address1
      stateId
      city
      zipCode
      warehouse_name
      isDeleted
      isActive
      customerId
      createdAt
    }
  }
}
`

export const GET_RECEIVER_DATA_BY_ID = gql`
query GetReceiversDetailsById($getReceiversDetailsByIdId: ID) {
  getReceiversDetailsById(id: $getReceiversDetailsByIdId) {
    id
    name
    phone
    address1
    stateId
    city
    warehouse_name
    zipCode
    customerId
  }
}
`

export const GET_USER_FRANCHISE_DETAILS = gql`
query getUserFranchiseDetails {
    getUserFranchiseDetails {
      id
      franchise {
        id
        defaultPrepaidPrice
        defaultCodFlightPrice
      }
    }
  }
`;